import Vue from 'vue';
import { TooltipDirective } from './Tooltip/tooltip.directive';

Vue.directive('tooltip', TooltipDirective);
